
<img alt="bullyiedchild.jpg" src="/images/blogs/bullyiedchild.jpg">
<br/><br/>
Firstly, if you have a highly sensitive child or a child who is a bit different in some way or
another they will inevitably become the target of a bully at some time in their lives. One
important aspect is knowing that your child is being bullied and therefore being able to
support them and help by being the adult that they can trust to confide in who will make a
difference.
<br/><br/>
Collecting your children from school personally can give you a very good gauge of what is
happening with them emotionally. Looking at their body language as they come out of
school will give you clues as to how their day went. Thin tight lips convey that something is
up. Quieter than their normal greeting and slinking off to their room when they get home
might mean that their day had not been as good as it could have been. Often children find
they are unable to speak about things that have happened until they have come in and had
time to process the events under their duvet and to come to terms with what has happened
in their day. Sometimes they will not want you to be in the room and other times they will
appreciate an empathetic listening ear. They will usually take their time but will eventually
come out with what has been happening and at least then you can do something about it.
Often a sensitive child will not want the focus on themselves so will not want to report
bullying to a teacher and they will be scared of reprisals by the bully if they are found out
that they have told the teacher what has been happening. Your child will normally feel relief
from being able to tell someone especially if it has been happening for a little while. It is
important for you to judge whether this is just a phase in a friendship or if it is bullying. We
can all understand that friendships have their ups and downs but if the friends are not being
friends it may be time to look for a new group to join. Parents can really help a child by
listening carefully and getting the facts straight about what has been happening. This is best
done in a very calm manner with empathy and understanding of how it is affecting your
child. This will immediately make them feel more valued and help their self-esteem.
If the bullying is happening at school the school must be told about it so that something can
be done about it. Often the teachers will know which children are the “bullies” and which
ones are the likely “victims”. It is useful for them to have details of names of who was
present, exactly what was said or done and when and if any other actions predated the
incident. If this is an ongoing issue, keep a diary of the incidents and what has been said to
the teacher and what has been done. Don’t be worried about keeping going back until some
remedy has been sought. A series of smaller incidents can build up until one big incident
makes it too much for your child to bear anymore and they will tell you. Some of the smaller
incidents may seem pretty petty but if these are nipped in the bud then the big incident will
never happen. Check with your child that the issues have been resolved and that things
have settled down.
<br/><br/>
Bullying can be very damaging if it is done in front of other children too as this isolates the
victim so gaining the support of other children to stand up to the bully is really useful. A lot
of the anti-bullying strategies that schools are promoting are that no one should be a
bystander to bullying and everyone should be encouraged to speak out and stop it
happening.
<br/><br/>
If the incident is happening within the home environment the family issues need to be
addressed. Allowing this behaviour to continue can cause a lot of damage that will take a
long time to repair. If with family friends it is best to have discussions with the other child’s
parents. Although this is often difficult and awkward and may lead to friendships with the
parties being broken, it is better to have friends that are true friends rather than “so-called”
friends. Children will have banter and ups and downs in their friendships but by definition
bullying is an ongoing problem with one party being the victim. Friends will move on to
make different friends and learning that this is part of life’s rich tapestry will make your child
more resilient in the world.
<br/><br/>
Bullying does not need to be physical but is easier to address as there is physical evidence of
damage done but verbal bullying or exclusion can be more deeply felt by the victim. A
wound can heal but damage to someone’s self-esteem can last for years.
Preventing your child being bullied in the first place is a good approach. The Skill Tree
Company focuses on workshops teaching children to build skills for life that will teach them
not to be the victim and how to deal with bullies. These will also teach them to recognise
what true friendship is about and how to recognise when a “so called” friend is not actually
being a friend at all. Watch this clip of advice from a child about bullying.
<iframe width="700" height="394" src="https://www.youtube.com/embed/fWgcsdJ86Do" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen title="An Interview about Bullying"></iframe>
Happy, popular children rarely get bullied. Try and encourage your children to build strong
friendships. Make time for playdates to encourage bonding with other children out of school
so it makes it easier for them in school. Before starting a new school it is useful to arrange
for your child to meet some of the children beforehand and encourage friendships. Older
children will be attractive to other kids if they are the cool kid. It might be that they are
good at football or basketball or they may play guitar in a band or are good with computers.
Having a skill that is in demand by other kids will help them to rise in the hierarchy of the
friendship groups and therefore will not be bullied. It is useful during playdates to be aware
of the conversations that the children are having with each other. If the friendship seems
fairly equal, this is a really good sign whereas when the relationship is uneven with one child
holding all the power this is when bullying can become an issue. Parents often send the
children off to their bedroom, playroom or garden during playdates. Make it your business
to be aware of what is happening and how the friends are interacting without being too
obvious. Popping in and offering drinks or snacks will give you a snapshot of what is going
on. It is also useful to speak to your child after the playdate to see how they perceive the
friendship.
<br/><br/>
We also can offer a workshop if your child is on the other side of the fence and you have the
child that is the bully. This can also be hard on the parent on understanding how to help
your child as these children often need the most help. Again we can offer strategies to help
the “bullies” understand their own emotions and build better self-esteem.
<br/><br/>
